// Define available form field types
export const AVAILABLE_TYPES = [
  'checkbox',
  'room-checkbox',
] as const
// This makes FormFieldType a union of the string literals in AVAILABLE_TYPES
// Avoiding the need to update multiple places when adding new types
export type FormFieldType = typeof AVAILABLE_TYPES[number]
export const DEFAULT_TYPE: FormFieldType = 'checkbox'

export interface BaseFieldProps {
  label: string;
  disabled?: boolean;
  defaultValue?: any;
}

export interface CheckboxFieldProps extends BaseFieldProps {
  'type-render': 'checkbox';
  items: Array<{ key: any; label: string }>;
  multiple?: boolean;
  hideDetails?: string;
  itemTitle?: string;
  itemValue?: string;
  component?: string;
}

export interface RoomCheckboxFieldProps extends BaseFieldProps {
  'type-render': 'room-checkbox';
  items: Array<{ key: any; label: string, type: 'DR' | 'LP' }>;
  component?: string;
}

export type AppAggregateFormBuilderField =
  | CheckboxFieldProps
  | RoomCheckboxFieldProps

export const defaultFieldProps: { [K in FormFieldType]: Partial<AppAggregateFormBuilderField> } = {
  checkbox: {
    'type-render': 'checkbox',
    disabled: false,
    defaultValue: [],
    items: [],
    multiple: true,
    hideDetails: '',
    itemTitle: 'label',
    itemValue: 'key',
    component: 'AppMultiSelect',
  },
  'room-checkbox': {
    'type-render': 'room-checkbox',
    disabled: false,
    defaultValue: [],
    items: [],
    component: 'RoomCheckboxes',
  },
}

// Merge default props with scheme
export function mergeFieldProps(scheme: AppAggregateFormBuilderField): AppAggregateFormBuilderField {
  const type = (scheme['type-render'] && AVAILABLE_TYPES.includes(scheme['type-render']))
    ? scheme['type-render']
    : DEFAULT_TYPE
  return { ...defaultFieldProps[type], ...scheme } as AppAggregateFormBuilderField
}

// Initialize form data using merged defaults
export function initFormData(
  aggregateScheme: Record<string, AppAggregateFormBuilderField>,
): Record<string, any> {
  const data: Record<string, any> = {}
  for (const key in aggregateScheme) {
    const merged = mergeFieldProps(aggregateScheme[key])
    data[key] = merged.defaultValue
  }
  return data
}
